import { Navigate } from 'react-router-dom'
import AuthGuard from '../auth/AuthGuard'
import NotFound from '../views/sessions/NotFound'
import pagesRoutes from '../views/pages/pagesRoutes'
import pageLayoutRoutes from '../views/page-layouts/PageLayoutRoutees'
import { dashboardRoutes } from '../views/dashboard/DashboardRoutes'
import sessionRoutes from '../views/sessions/SessionRoutes'
import MatxLayout from '../components/MatxLayout/MatxLayout'

const RootRedirect = () => {
    const role = window.localStorage.getItem('ROLE')
    return (
        <Navigate
            to={role === 'SA' ? '/dashboard/analytics' : '/dashboard/default'}
            replace
        />
    )
}

export const AllPages = () => {
    const all_routes = [
        {
            path: '/',
            element: (
                <AuthGuard>
                    <MatxLayout />
                </AuthGuard>
            ),
            children: [
                {
                    index: true,
                    element: <RootRedirect />,
                },
                ...dashboardRoutes,
                ...pageLayoutRoutes,
                ...pagesRoutes,
            ],
        },
        ...sessionRoutes,
        {
            path: '*',
            element: <NotFound />,
        },
    ]

    return all_routes
}
